module.exports = __webpack_public_path__ + "img/blog8.9bba01f8.jpg";